var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('g-master',{ref:"masterComponent",attrs:{"name":_vm.master.endpoint,"endpoint":_vm.master.endpoint,"tableSetup":_vm.master.tableSetup,"modalFieldsSetup":_vm.master.modalFieldsSetup,"actions":false,"parentData":_vm.parentData}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3117e7da","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/customization/GlobalBPOCore/pages/LiqMarc/LiqMarcDetails.vue
// module id = null
// module chunks = 